export default __webpack_public_path__ + "static/media/1280x500_funpark.26fb1d40.jpg";